import { businessDataPages } from '../configs/tools/setup/business-data';

export const businessData = {
  id: 'business-data',
  name: _TL_('Business data'),
  description: _TL_('Upload and manage your business data feeds.'),
  route: 'feeds/attribute',
  children: businessDataPages,
};
